var baseGet = require('./_baseGet');

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_basePropertyDeep.js
 ** module id = 235
 ** module chunks = 0
 **/